module.exports = __webpack_public_path__ + "static/media/5-9.94d54ce4.mp3";